<template>
  <v-container fluid grid-list-sm>
    <v-data-table
      :headers="headers"
      :items="enrichedDesserts"
      class="elevation-1"
      item-key="job_id"
      :show-select="show_select"
      v-model="dataWork"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:top>
        <v-card-title>
          ตำแหน่งงานที่เปิดรับสมัคร
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-badge
            v-if="dataWork.length > 0 ? true : false"
            bordered
            color="error"
            overlap
            :content="dataWork.length"
            class="d-none"
          >
            <v-btn bordered color="warning" @click="select_work()"
              ><v-icon left>mdi-plus-circle-outline</v-icon
              >กรอกข้อมูลสมัคร</v-btn
            >
          </v-badge>
        </v-card-title>
      </template>
      <template v-slot:[`item.#`]="{ index }" >
        {{(index+1)}}
      </template>
      <template v-slot:[`item.djob_skill`]="{ item }">
        <div v-html="item.djob_skil"></div>
      </template>
      <template v-slot:[`item.showDetail`]="{ item }">
        <v-btn color="info" dense @click="showDetail(item)">
          แสดงรายละเอียด</v-btn
        >
      </template>
    </v-data-table>
    <div class="text-center">
      <v-dialog v-model="dialog_detailJob" persistent width="800">
        <v-card>
          <v-card-title class=" grey lighten-2">
            รายละเอียดข้อมูลงานที่เปิดรับสมัคร
          </v-card-title>

          <v-card-text class="pt-2 black--text">
            <!-- {{itemDetailJob}} -->
            <v-row>
              <v-col lg="3">ตำแหน่งที่เปิดรับสมัคร</v-col>
              <v-col lg="9">{{itemDetailJob.job_name}}</v-col>
            </v-row>
            <v-row>
              <v-col lg="3">ระดับการศึกษา</v-col>
              <v-col lg="9">{{itemDetailJob.edu_level}}</v-col>
            </v-row>
            <v-row>
              <v-col lg="3">จำนวนที่เปิดรับ</v-col>
              <v-col lg="9">{{itemDetailJob.djob_no}}</v-col>
            </v-row>
            <v-row>
              <v-col lg="3">เพศ</v-col>
              <v-col lg="9">{{itemDetailJob.e_job_sex_name}}</v-col>
            </v-row>
            <v-row>
              <v-col lg="3">คุณสมบัติ</v-col>
              <v-col lg="9" >{{itemDetailJob.djob_detail}}</v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog_detailJob = false">
              ปิดหน้านี้
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    dataWork: [],
    headers: [
      {
        text: "#",
        value: "#",
      },
      {
        text: "ชื่อตำแหน่ง",
        value: "job_name",
      },
      {
        text: "เพศ",
        value: "e_job_sex_name",
      },
      {
        text: "ระดับการศึกษา",
        value: "edu_level",
      },
      {
        text: "จำนวนที่เปิดรับ",
        value: "djob_no",
      },
      {
        text: "รายละเอียด",
        value: "showDetail",
      },
    ],
    deserts: [],
    dialog_detailJob:false,
    itemDetailJob:Array()
  }),
  mounted() {},
  props: {
    show_select: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    initialize() {
      if (this.$store.getters.get_listJob.length == 0)
        this.$store.dispatch("get_listJob");
      if (this.$store.getters.get_selJob.length > 0) {
        this.dataWork = this.$store.getters.get_selJob;
      }
    },
    showDetail(item) {
      this.dialog_detailJob=true;
      this.itemDetailJob = item;
    },
    async select_work() {
      // console.log("get_selJob", this.$store.getters.get_selJob);
      // console.log("get_userRegis", this.$store.getters.get_userRegis.length);

      if (
        this.$store.getters.get_userRegis.length === 0 ||
        !this.$store.getters.get_userRegis.length
      ) {
        this.$store.state.statShowFrmLogin = true;
        // console.log("=>2", this.$store.state.statShowFrmLogin);
      } else {
        // console.log("=>3", this.$store.getters.get_userRegis);
        await this.$router.push("/resume");
        await this.$store.dispatch("set_selJob", this.dataWork);
      }
    },
  },
  computed: {
    enrichedDesserts() {
      return this.$store.getters.get_listJob.map((x) => ({
        ...x,
        isSelectable1:
          this.$store.getters.get_selJob.find(
            (valFind) => valFind.job_id == x.job_id,
            1
          ) != undefined
            ? true
            : false,
      }));
    },
  },
  watch: {
    dataWork(val) {
      this.$store.dispatch("set_selJob", val);
    },
  },
  created() {
    this.initialize();
  },
};
</script>
